define([
    'backbone.marionette',
    'd3'
], function(
    Marionette,
    d3
    ) {
    return Marionette.CollectionView.extend({
        tagName: 'g',
        initialize: function() {
            this.$el = d3.select(document.createElementNS(
                "http://www.w3.org/2000/svg", this.tagName));
            if(this.className) {
                this.$el.classed(this.className, true);
            }
            this.el = this.$el.node();
        },

        _insertBefore: function(childView, index) {
            return false;
        }
    });
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/collection.js